import React from 'react';
import "./index.scss";

const WaitingWave = ((props = {}) => {
  const {
    color = "rgba(0,0,0,.2)",
    className = '',
    style,
  } = props;

  return (
    <div 
      className={`waiting-wave ${className}`} 
      style={{
        "--wave-color" : color,
        ...style,
      }}
      >
      <i></i><i></i><i></i>
    </div>
  )
});
export default WaitingWave;